const LISTE_ECHEANCE_A_RAPPROCHER = {
  actions: {
    filtre: 'Filtre',
    search: 'Rechercher',
    export: 'Exporter',
  },
  tab: {
    codeAvenantBail: 'Bail',
    codeFace: 'Faces/Ecrans',
    nomBailleur: 'Bailleur',
    adresse: 'Adresse produit',
    periodeEcheance: 'Période échéance',
    dateEcheance: 'Date échéance',
    dateFinBail: 'Date fin bail',
    etatBail: 'Etat bail',
    blocageReglement: 'Bloc.',
    motifBlocage: 'Motif',
    montantEcheanceHT: 'Mnt. HT',
    montantEcheanceTTC: 'Mnt. TTC',
    modeReglement: 'Mode(s) règlement',
    affectation: 'Affectation(s)',
    commentaireCommande: 'Commentaire échéance bail',
    villePanneau: 'Ville produit',
    materielType: 'Type matériel',
    formatType: 'Format matériel',
    indexation: 'Index.',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    agence: 'Agence(s)',
    modeReglement: 'Mode de règlement',
    codeAvenantBail: 'Bail',
    codeFace: 'Faces/Ecrans',
    nomBailleur: 'Bailleur',
    blocageReglement: 'Blocage paiement',
    motifBlocage: 'Motif blocage',
    montantEcheanceHT: 'Montant HT',
    montantEcheanceTTC: 'Montant TTC',
    commentaire: 'Commentaire',
    etatBail: 'Etat du bail',
    datesFinContrat: 'Date fin du bail',
    villePanneau: 'Ville du produit',
    adresse: 'Adresse du produit',
    estIndexe: 'Avec indexation',
    au: 'au',
    errors: {
      dateDebutGreaterDateFin: 'La date de début est plus grande que la date de fin',
    },
  },
  infoAffectation: {
    title: 'Affectation(s) du matériel {code}',
    noAffectation: 'Aucune affectation pour ce matériel',
  },

};

export default LISTE_ECHEANCE_A_RAPPROCHER;
